import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { URLS } from '@wix/da-url';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { DEFAULT_BACKGROUND_ID } from '../../redux/constants';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import s from './BackgroundThumb.scss';
function getThumbVariant(variant, darkThumbUrl, lightThumbUrl, greenThumbUrl) {
    switch(variant){
        case 'light':
            return lightThumbUrl;
        case 'green':
            return greenThumbUrl;
        case 'dark':
        default:
            return darkThumbUrl;
    }
}
const BackgroundThumb = ({ background: { darkThumbUrl, lightThumbUrl, greenThumbUrl = lightThumbUrl, isPremium, backgroundId = DEFAULT_BACKGROUND_ID }, canUseCore, isSelected, isLoading, variant, onBackgroundPicked, onBackgroundPreviewed, className })=>{
    const { t } = useTranslation();
    const canPick = !isPremium || canUseCore;
    const startPreview = useCallback(()=>{
        onBackgroundPreviewed(backgroundId);
    }, [
        backgroundId,
        onBackgroundPreviewed
    ]);
    const endPreview = useCallback(()=>{
        onBackgroundPreviewed();
    }, [
        onBackgroundPreviewed
    ]);
    const pick = useCallback(()=>{
        if (!canPick) {
            return;
        }
        onBackgroundPicked(backgroundId);
    }, [
        backgroundId,
        canPick,
        onBackgroundPicked
    ]);
    const src = getThumbVariant(variant, darkThumbUrl, lightThumbUrl, greenThumbUrl);
    const isDefault = backgroundId < 0;
    return /*#__PURE__*/ React.createElement(BiButton, {
        className: classnames(s['root'], isPremium && !canUseCore && s['core'], isSelected && s['selected'], isDefault && s[`default-${variant}`], variant && s[`thumb-variant-${variant}`], className),
        style: {
            backgroundImage: src ? `url('${src}')` : undefined
        },
        onMouseEnter: startPreview,
        onMouseLeave: endPreview,
        onClick: pick,
        biData: canPick ? BiData({
            evid: 373,
            background_id: backgroundId,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            core_only: isPremium ? 1 : 0
        }) : undefined
    }, isPremium && /*#__PURE__*/ React.createElement(CoreSymbol, {
        corePackage: "core_access",
        size: IconSize.SMALL,
        className: s['core-icon']
    }), isSelected && !isLoading && /*#__PURE__*/ React.createElement(CheckIcon, {
        size: IconSize.SMALL,
        disableDefaultColors: true,
        className: s['check-icon']
    }), isDefault && !isSelected && /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t('deviation.backgrounds.original')), !canPick && /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: URLS.CORE_MEMBERSHIP,
        biData: BiData({
            evid: 375,
            background_id: backgroundId,
            referral_info: ReferralType.BACKGROUND_MODAL
        })
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "deviation.backgrounds.coreToUnlock"
    }, "Become ", /*#__PURE__*/ React.createElement(CoreBadge, {
        className: s['core-badge'],
        size: "small"
    }), " to unlock"))), isLoading && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['loader']
    }));
};
export default BackgroundThumb;

//# sourceMappingURL=BackgroundThumb.js.map